import React, { useContext } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useParams,
} from 'react-router-dom';
import Dashboard from './dashboard/dashboard.uha';
import Settings from './settings/settings.uha';
import MyInstitution from './myinstitution/myinstitution.uha';
import PracticePlaces from './practiceplaces/practiceplaces';
import EvaluationActivitiesWrapper from './evaluation/evaluationactivities';
import PageNotFound from './pages/pagenotfound';
import { PrivacyPolicyLoggedIn } from './policy/rightsandprivacy';
import {
  AboutAnalyticsPageLoggedIn,
  AboutCookiesPageLoggedIn,
} from './login/about';
import { UhaUserContext } from './user/UhaUserStore';
import UhaUserGodtaBetingelserPage from './policy/godtabetingelserpage.uha';
import { UserType } from './util/userType';
import CalendarPage from './calendaruha/calendaruha';

const CalendarRedirect = () => {
  const { pathname } = useLocation();

  return <Navigate to={`/calendar${pathname}`} replace />;
};

const AgreementRedirect = () => {
  const { avtaleId } = useParams<{ avtaleId: string }>();

  return (
    <Navigate
      to={`/practiceplaces/practiceplaceagreement/${avtaleId}`}
      replace
    />
  );
};

const TopRoutesUha = () => {
  const { uhaUser } = useContext(UhaUserContext);

  if (uhaUser && !uhaUser.innstillinger.harGodtattBetingelser) {
    return <UhaUserGodtaBetingelserPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/calendar/*" element={<CalendarPage />} />
      <Route
        path="/activity/:activityId/:tab?"
        element={<CalendarRedirect />}
      />
      <Route
        path="/evaluation/*"
        element={<EvaluationActivitiesWrapper userType={UserType.UH} />}
      />
      <Route path="/myinstitution/*" element={<MyInstitution />} />
      <Route
        path="/myorganization/agreements/:avtaleId"
        element={<AgreementRedirect />}
      />
      <Route path="/practiceplaces/*" element={<PracticePlaces />} />
      <Route path="/policy" element={<PrivacyPolicyLoggedIn />} />
      <Route path="/cookies" element={<AboutCookiesPageLoggedIn />} />
      <Route path="/analytics" element={<AboutAnalyticsPageLoggedIn />} />
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
  );
};

export default TopRoutesUha;
